import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  CommonErrorMsg,
  confirmDelete,
  ErrorMsg,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../../Util/common";
import { KendoLoader } from "../../../Kendo/kendo_loader";
import { KendoGrid } from "../../../Kendo/kendo_grid";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../../Util/axios_core_helper";
import { KendoDropdown } from "../../../Kendo/kendo_dropdown";
import { toast } from "react-toastify";

const DecorationItem = () => {
  const modalRef = useRef(null);
  const ItemmodalRef = useRef(null);
  const [editVisible, setEditVisible] = useState(false);
  const [Dup, setDup] = useState(false);
  const [ItemDup, setItemDup] = useState(false);
  const [OverSize, setOverSize] = useState(false);
  const [error, setError] = useState({});
  const [Loading, setLoading] = useState(false);
  const [CategoryList, setCategoryList] = useState([]);
  const [ItemList, setItemList] = useState([]);
  const [refreshflag, setrefreshflag] = useState(0);
  const [imageList, setImageList] = useState([]);
  const [selectedImageID, setSelectedImageID] = useState(null);
  const imageListRef = useRef(imageList);
  const [dragging, setDragging] = useState(null);
  const [removedImageIds, setRemovedImageIds] = useState();
  const [ytLink, setytLink] = useState(false);
  const [image, setImage] = useState(null);

  const [Category, setCategory] = useState({
    categoryID: 0,
    categoryName: "",
    image: "",
    popular: "",
    imagePath: "",
  });

  const [Item, setItem] = useState({
    CategoryID: 0,
    ItemID: 0,
    ItemName: "",
    Rate: "",
    StartRate: "",
    EndRate: "",
    Quantity: "",
    YoutubeLink: "",
    Description: "",
    ImagesModel: [],
    Images: [],
    OldimagePath: [],
    ImageSortOrder: 0,
    MeridianCalendlyLink: "",
    NON_MeridianCalendlyLink: "",
  });

  const handleToggleClick = async (id, newStatus) => {
    await corefetch(
      `Rental/UpdateRCategoryPoular?CategoryID=${id}&Ispopular=${newStatus}&ModifiedBy=${sessionUser()}`,
      true,
      false,
      false,
      true
    );
  };

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (event.target.classList.contains("status-toggle")) {
        const id = event.target.getAttribute("data-id");
        const newStatus = event.target.checked ? true : false;
        handleToggleClick(id, newStatus);
      }
    };
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    setCategory({
      CategoryID: 0,
      ItemID: 0,
      ItemName: "",
      Rate: "",
      Quantity: "",
      YotubeLink: "",
      Description: "",
      ImagesModel: [],
      Images: [],
      OldimagePath: [],
      ImageSortOrder: 0,
      MeridianCalendlyLink: "",
      NON_MeridianCalendlyLink: "",
    });
    setError({});
    setDup(false);
    setEditVisible(false);

    const form = document.getElementById("form-category-config");
    if (form) {
      form.reset();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    const InvalidFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (InvalidFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      setOverSize(false);
      setCategory((prev) => ({
        ...prev,
        image: "",
      }));
      return;
    }

    if (!file) {
      setOverSize(false);
      setCategory((prev) => ({
        ...prev,
        image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;
      setOverSize(isFileTooLarge);

      if (!isFileTooLarge) {
        let temp = Category;
        temp.image = file;
        setCategory(temp);
        document.getElementById("image-name").value = file;
      }
      onValidation("Image", e.target.value);
    }
  };

  const fetchData = async () => {
    try {
      const list = await corefetch("Decoration/GetDecorationItemDetails");
      setItemList(list);
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const onParentEditClick = async (e) => {
    let imgModel = [];
    if (e.imageModels) {
      for (let i = 0; i < e.imageModels.length; i++) {
        imgModel.push(e.imageModels[i]);
      }
    }
    const updatedImgModel = imgModel.map((img) => ({
      ...img,
      isCoverPhoto: img.isCoverPhoto, // Keep the original value
    }));
    setItem({
      ItemID: e.itemID,
      ItemName: e.itemName,

      YoutubeLink: e?.youtubeLink || "",
      MeridianCalendlyLink: e?.meridianCalendlyLink || "",
      NON_MeridianCalendlyLink: e?.noN_MeridianCalendlyLink || "",
      Description: e.description,
      Images: e.imageModels?.map((img) => img.imagePath) || [],
      ImagesModel: imgModel
        ? imgModel.map((x) => {
            return {
              Path: x.imagePath,
              Id: x.galleryID,
              SortOrder: x.sortOrder,
            };
          })
        : [],
      OldimagePath: e.imageModels?.[0]?.imagePath || "",
    });
    setImageList(updatedImgModel);
    setEditVisible(true);

    const modal = new bootstrap.Modal(document.getElementById("add_Item"));
    modal.show();
  };

  const handleParentDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `Decoration/DeleteDecorationItem?id=${
          e.itemID
        }&deletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        fetchData();
        setrefreshflag((prev) => prev + 1);
      });
    };
    confirmDelete(onDelete);
  };

  const onItemAdd = async (e) => {
    setItem((prev) => ({
      ...prev,
      categoryID: e.categoryID,
    }));
    const modal = new bootstrap.Modal(document.getElementById("add_Item"));
    modal.show();
  };

  const onItemSubmit = async (e) => {
    e.preventDefault();

    const err = ValidateForm(e);
    const youtubePattern = /^https:\/\/.*youtube.*$/;
    const calendlyPattern = /^https:\/\//;
    const hasCoverPhoto = imageList.some((img) => img.isCoverPhoto === 1);

    let newErrors = { ...error }; // Preserve existing errors

    // Validate form errors
    if (err && !OverSize) {
      newErrors = { ...newErrors, ...err };
    }

    // Validate YouTube Link
    if (Item.YoutubeLink && !youtubePattern.test(Item.YoutubeLink)) {
      newErrors.YoutubeLink = "Invalid YouTube URL";
    }

    if (!hasCoverPhoto) {
      if (imageList.length > 0) {
        toast.error("Please select a cover photo from the uploaded images!");
        return;
      } else {
        // toast.error("Please select a cover photo before submitting!");
      }
    }

    if (Object.values(newErrors).some((value) => Boolean(value))) {
      setError(newErrors);
      return;
    }
    // Proceed with form submission if no errors
    if (!OverSize && !Dup) {
      const formData = new FormData();

      if (Item.Images && Array.isArray(Item.Images) && Item.Images.length > 0) {
        Item.Images.forEach((file) => {
          formData.append("Images", file);
        });
      }

      if (removedImageIds && removedImageIds.length > 0) {
        formData.append("RemovedImageIds", removedImageIds);
      }

      // Append image models
      imageList.forEach((imageModel, index) => {
        if (imageModel) {
          formData.append(
            `ImageModels[${index}].GalleryID`,
            imageModel.galleryID || 0
          );
          formData.append(
            `ImageModels[${index}].ImageID`,
            imageModel.imageID || 0
          );
          formData.append(
            `ImageModels[${index}].ImagePath`,
            imageModel.imagePath || ""
          );
          formData.append(
            `ImageModels[${index}].SortOrder`,
            imageModel.SortOrder || 0
          );
          formData.append(
            `ImageModels[${index}].Images`,
            imageModel.fileData || ""
          );
          formData.append(
            `ImageModels[${index}].IsCoverPhoto`,
            imageModel.isCoverPhoto || 0
          );
        }
      });

      formData.append("ItemID", Item.ItemID);
      formData.append("ItemName", Item.ItemName);
      formData.append("Description", Item.Description);
      formData.append("YoutubeLink", Item.YoutubeLink);

      formData.append("OldimagePath", Item.OldimagePath);
      formData.append("SavedBy", sessionUser());
      formData.append("SelectedImageID", selectedImageID || 0);

      // Handle form submission
      setLoading(true);
      try {
        await corepost(
          "Decoration/InsertUpdateItem",
          formData,
          true,
          true,
          false,
          false
        );
        setLoading(false);
        setrefreshflag(refreshflag + 1);
        fetchData();
        clearItemForm();
        $("#Category-cancel").click();
      } catch (error) {
        console.error("Error while submitting the form:", error);
        setLoading(false);
      }
    }
  };

  const clearItemForm = () => {
    setLoading(false);
    $("#hide").click();
    setItem({
      CategoryID: 0,
      ItemID: 0,
      ItemName: "",
      Rate: "",
      Quantity: "",
      YoutubeLink: "",
      Description: "",
      ImagesModel: [],
      Images: [],
      OldimagePath: [],
      ImageSortOrder: 0,
      MeridianCalendlyLink: "",
      NON_MeridianCalendlyLink: "",
    });
    // setImage("");
    setImageList([]);
    setError({});
    setDup(false);
    setEditVisible(false);
    setRemovedImageIds("");
    const form = document.getElementById("form-item-config");
    if (form) {
      form.reset();
    }
    setSelectedImageID(0);
  };

  const handleItemFileChange = (event) => {
    const files = Array.from(event.target.files);
    const validImages = files.filter((file) => file.type.startsWith("image/"));
    const hasAvifFile = files.some(
      (file) => file.type === "image/avif" || file.name.endsWith(".avif")
    );

    if (hasAvifFile) {
      toast.error("Uploaded images contain unsupported formats.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    // if (files.length == 0 && imageList.length == 0) {
    //   onValidation("Image", event.target.value);
    //   return;
    // }
    if (validImages.length !== files.length) {
      setError({ ValidFile: true });
    } else {
      const newImageList = validImages.map((file, index) => ({
        imagePath: URL.createObjectURL(file),
        fileName: file.name,
        fileData: file,
        Id: index,
        selectedAsCover: false,
        Images: validImages,
        isCoverPhoto: 0,
      }));

      setImageList((prevImages) => [...prevImages, ...newImageList]);
      setItem((prevState) => ({
        ...prevState,
        Images: prevState.Images
          ? [...prevState.Images, ...validImages]
          : [...validImages],
      }));
      setError((prev) => ({ ...prev, Image: false, ValidFile: false }));
      //onValidation("Image", event.target.value);
      event.target.value = "";
    }
  };
  useEffect(() => {}, [Item, imageList]);

  const handleRemoveImage = (imageId, index) => {
    try {
      const wasCoverPhoto = imageList[index]?.isCoverPhoto === 1;
      const updatedImageList = imageList.filter((_, i) => i !== index);

      if (wasCoverPhoto && updatedImageList.length > 0) {
        // If the removed image was the cover photo, assign the first image as the new cover photo
        updatedImageList[0].isCoverPhoto = 1;
        setSelectedImageID(updatedImageList[0].galleryID || 0); // Update selectedImageID
      }

      setImageList(updatedImageList);

      setRemovedImageIds((prevRemovedIds = "") =>
        [...prevRemovedIds.split(","), imageId].filter(Boolean).join(",")
      );

      setItem((prevGallery) => ({
        ...prevGallery,
        Images: updatedImageList.map((item) => item.fileData || item),
      }));
    } catch (error) {
      console.error("Error removing image:", error);
    }
  };

  useEffect(() => {
    imageListRef.current = imageList;
  }, [imageList]);

  const handleImageSelect = (img, index) => {
    try {
      const updatedImageList = imageList.map((image, idx) => ({
        ...image,
        isCoverPhoto: idx === index ? 1 : 0,
      }));

      setImageList(updatedImageList);

      setSelectedImageID(img.galleryID || index);

      //refreshChildGrd();
    } catch (error) {
      console.error("Error selecting image:", error);
    }
  };

  const handleDragStart = (e, index) => {
    setDragging(index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, index) => {
    const newList = [...imageList];
    const draggedItem = newList.splice(dragging, 1)[0];
    newList.splice(index, 0, draggedItem);
    newList.forEach((item, newIndex) => {
      item.SortOrder = newIndex + 1;
    });
    setImageList(newList);
    setItem((prevGallery) => ({
      ...prevGallery,
      images: newList.map((item) => item.fileData || item),
    }));
    setDragging(null);
  };

  const onRowReorderChange = async (List) => {
    let ID = $(List.newRow).find("td").eq(0).text();
    let oldSortId = $(List.newRow).find("td").eq(1).text();
    let newSortId = $(List.oldRow).find("td").eq(1).text();
    await corefetch(
      `Decoration/SortItemSection?TypeId=${ID}&newSortId=${newSortId}&oldSortId=${oldSortId}`
    );
    setrefreshflag(refreshflag + 1);
  };
  const onValidationURL = (name, val) => {
    try {
      new URL(val.trim());
      setError((prevErr) => ({
        ...prevErr,
        [name]: false,
      }));
    } catch (error) {
      setError((prevErr) => ({
        ...prevErr,
        [name]: true,
      }));
    }
  };
  return (
    <>
      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    name={"Add"}
                    dataBsToggle={"modal"}
                    dataBsTarget={"#add_Item"}
                    dataBsDismiss={"modal"}
                  />
                </div>
              </div>
            </div>

            <div>
              <i>
                <span style={{ backgroundColor: "yellow" }}>Note:</span>
                This module supports drag-and-drop functionality, you can easily
                rearrange or move data as needed
              </i>
              <KendoGrid
                name={"RentalItem"}
                url={CorebaseURL + "Decoration/GetDecorationItemDetails"}
                // url={`${CorebaseURL}/Rental/GetRentalItemDetails?itemId=${itemID}`}
                schema={{}}
                columns={[
                  {
                    field: "itemID",
                    filterable: false,
                    hidden: true,
                  },
                  { field: "orderBy", hidden: true },
                  {
                    field: "categoryID",
                    filterable: false,
                    hidden: true,
                  },

                  {
                    field: "itemName",
                    title: "Item Name",
                    width: 150,
                  },

                  {
                    field: "description",
                    title: "About the item",
                    template: function (e) {
                      const maxLength = 50; // Set max length for display
                      return e.description.length > maxLength
                        ? `${e.description.substring(0, maxLength)}...`
                        : e.description;
                    },
                    width: 150, // Adjust the width as needed
                  },
                  {
                    field: "youtubeLink",
                    title: "YouTube Link",
                    width: 100,
                  },
                  // {
                  //   template: function (e) {
                  //     if (e.imagePath) {
                  //       return `<img src="${ImageURL}${e.imagePath}" width="40px" height="40px" />`;
                  //     }
                  //     return "";
                  //   },

                  //   title: "Image",
                  //   width: 50,
                  // },
                  {
                    field: "imagePath",
                    hidden: true,
                  },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={true}
                onEditClick={(e) => onParentEditClick(e)}
                onDeleteClick={(e) => {
                  handleParentDeleteClick(e);
                }}
                paggable={true}
                disableExportExcel={true}
                height={"60vh"}
                refreshWhen={refreshflag}
                enableRowReorderable={true}
                onRowReorder={onRowReorderChange}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal custom-modal fade"
        id="add_Item"
        role="dialog"
        ref={ItemmodalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered RentalItem"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editVisible ? "Edit Item" : "Add Item"}
              </h5>
              <button
                type="button"
                id="close"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearItemForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-item-config" onSubmit={onItemSubmit}>
                <input type="hidden" name="ID" value={Item.ItemID || 0} />

                <div className="row">
                  <div className="col-4 mb-3">
                    <div className="input-block">
                      <label className="form-label">
                        Item Name<span className="text-danger">*</span>{" "}
                        <InfoIcon content="Please provide a item name with a maximum length of 50 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={50}
                        className="form-control field"
                        name="ItemName"
                        value={Item.ItemName || ""}
                        placeholder="Item Name"
                        data-required="true"
                        onChange={(e) => {
                          setItem((prev) => ({
                            ...prev,
                            ItemName: e.target.value,
                          }));
                          onValidation("ItemName", e.target.value);
                          let dup;
                          if (Item.ItemID > 0) {
                            const matchingItem = ItemList.find(
                              (item) =>
                                item.itemName.trim().toLowerCase() ==
                                  e.target.value.trim().toLowerCase() &&
                                item.itemID != Item.ItemID
                            );

                            dup = matchingItem;
                            setDup(dup);
                          } else {
                            const matchingItem = ItemList.find(
                              (item) =>
                                item.itemName.trim().toLowerCase() ==
                                e.target.value.trim().toLowerCase()
                            );
                            dup = matchingItem;
                            setDup(dup);
                          }
                        }}
                      />
                      {error.ItemName && (
                        <ErrorMsg text="Item Name is required." />
                      )}
                      {Dup && <ErrorMsg text="Item Name is already exist." />}
                      {/* <CommonErrorMsg
                        text={
                          error.ItemName
                            ? "Item Name is required."
                            : "Item Name is already exist."
                        }
                        IsError={error.ItemName || error.ItemDup}
                      /> */}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      About the item <span className="text-danger">*</span>
                      <InfoIcon content="Please provide a About the item with a maximum length of 1000 characters." />
                    </label>
                    <textarea
                      type="text"
                      maxLength={1000}
                      className="form-control field"
                      name="Description"
                      id="Description"
                      value={Item.Description || ""}
                      placeholder="Description"
                      data-required="true"
                      onChange={(e) => {
                        setItem((prev) => ({
                          ...prev,
                          Description: e.target.value,
                        }));
                        onValidation("Description", e.target.value);
                      }}
                    />

                    <CommonErrorMsg
                      text="Description is required"
                      IsError={error.Description}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Youtube Link</label>
                    <textarea
                      type="text"
                      className="form-control field"
                      name="YoutubeLink"
                      value={Item.YoutubeLink || ""}
                      placeholder="Youtube Link"
                      onChange={(e) => {
                        const youtubePattern = /^https:\/\/.*youtube.*$/;
                        const value = e.target.value;
                        setItem((prev) => ({
                          ...prev,
                          YoutubeLink: value,
                        }));
                        setError((prevError) => ({
                          ...(prevError || {}),
                          YoutubeLink:
                            value && !youtubePattern.test(value)
                              ? "Please enter a valid YouTube URL"
                              : "",
                        }));
                      }}
                    />
                    {error.YoutubeLink && (
                      <CommonErrorMsg
                        text="Please enter a valid YouTube URL"
                        IsError={error.YoutubeLink}
                      />
                    )}
                  </div>
                </div>
                <div className="row">
                  {/* Upload Image */}
                  <div className="col-md-4">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Upload Image <span className="text-danger">*</span>
                        <InfoIcon
                          content="Please ensure each image is uploaded within a maximum size of 500KB.
                  Please upload the images in JPEG, JPG, or PNG format."
                        />
                      </label>
                      <input
                        id="lFile"
                        className="form-control field"
                        type="file"
                        name="Image"
                        accept="image/*"
                        multiple
                        onChange={handleItemFileChange}
                      />
                      <CommonErrorMsg
                        text={
                          error.Image
                            ? "Image is required"
                            : "Please upload Image file only"
                        }
                        IsError={error.Image || error.ValidFile}
                      />
                    </div>

                    {/* Image Preview Section */}

                    <input
                      type="hidden"
                      name="Image"
                      id="image-name"
                      data-required="true"
                      value={Item.Images || ""}
                    />
                    <input
                      type="hidden"
                      name="OldimagePath"
                      value={Item.OldimagePath}
                    />
                  </div>

                  {/* First YouTube Link */}

                  <div className="d-flex flex-wrap">
                    {imageList &&
                      imageList.length > 0 &&
                      imageList.map((img, index) => (
                        <div
                          key={index}
                          className="list-item"
                          style={{
                            position: "relative",
                            display: "inline-block",
                            textAlign: "center",
                            width: "120px",
                            height: "140px",
                            backgroundColor:
                              selectedImageID === img?.galleryID ||
                              img.isCoverPhoto === 1
                                ? "#ffedd7"
                                : "transparent",
                          }}
                          onClick={() => handleImageSelect(img, index)}
                          draggable="true"
                          onDragStart={(e) => handleDragStart(e, index)}
                          onDragOver={handleDragOver}
                          onDrop={(e) => handleDrop(e, index)}
                        >
                          <input
                            type="radio"
                            className="imgFlagContainer"
                            style={{ display: "none" }}
                            value={img?.Id}
                          />
                          <img
                            src={
                              img?.galleryID > 0
                                ? ImageURL + img?.imagePath
                                : img?.imagePath
                            }
                            style={{
                              maxWidth: "100px",
                              minWidth: "100px",
                              height: "100px",
                              display: "block",
                              margin: "0 auto",
                            }}
                          />
                          {img.isCoverPhoto === 1 && (
                            <h6
                              style={{
                                margin: "5px 0 0",
                                fontSize: "12px",
                                lineHeight: "1.2",
                                height: "auto",
                                overflow: "hidden",
                              }}
                            >
                              Cover Image
                            </h6>
                          )}
                          <button
                            style={{
                              position: "absolute",
                              top: "-10px",
                              right: "-10px",
                              background: "red",
                              color: "white",
                              border: "none",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                            }}
                            className="close"
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveImage(img?.galleryID, index);
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                  </div>
                </div>

                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="Category-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearItemForm();
                      }}
                    />
                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearItemForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add Item Modal --> */}
    </>
  );
};

export default DecorationItem;
